export const ONBOARDING_STARTED = 'onboarding_started';
export const QUESTION_SUBMITTED = "question_page_completed";
export const FACT_SUBMITTED = "fact_page_completed";
export const ENTER_AGE_SUBMITTED = 'age_page_completed';
export const QUIZ_RESULTS_SUBMITTED = "brainstatus_page_click";
export const CREATING_PROFILE = "analyzing_answers_page_show";
export const ENTER_EMAIL_SHOWN = 'email_page_show';
export const ENTER_EMAIL_SUBMITTED = 'email_page_completed';
export const CONSENT_EMAIL_SHOWN = 'email_consent_shown';
export const CONSENT_EMAIL_SUBMITTED = 'email_consent_click';
export const ENTER_NAME_SUBMITTED = 'OB_name_click';
export const FOUR_WEEKS_RESULT_SUBMITTED = 'OB_result_click';
export const SIGNUP_SUCCESS = 'account_created';
export const PAYWALL_SHOWN = 'paywall_page_show';
export const PLAN_CHOSEN = 'paywall_page_completed';
export const CHECKOUT_SHOWN = 'subs_purchase_show';
export const CARD_BRAND_CHOSEN = 'card_checkout_chosen';
export const PAYWALL_CLOSED = 'subs_purchase_screen_close';
export const BUY_SUBSCRIPTION_TAPPED = 'subs_purchase_started';
export const PAYMENT_ANIMATION = 'payment_animation_screen';
export const SUBSCRIBED = 'subs_purchase_completed';
export const PAYMENT_DECLINE = 'subs_purchase_failed';
export const DECLINE_TRY_AGAIN = 'payment_declined_try_again';
export const SUCCESS_PAGE_SHOWN = 'OB_success_shown';
export const DOWNLOAD_TAP = 'OB_success_click';
export const TERMS_TAP = 'terms_of_use_tap';
export const POLICY_TAP = 'privacy_policy_tap';
export const PAYMENT_POLICY_TAP = 'payment_policy_tap';
